// src/constants.jsx

export const COLORS = {
  purpleLight: "#7958D2",
  purpleDark: "#543D92",
  yellowDark: "#F1D067",
  gray900: "#111827",
  yellowLight: "#F2E0BA",
  backgroundLight: "#fafafa",
  white: "#ffffff",
  cardsBackground: "#F9FAFB",
  gray800: "#424242",
};
